export default "__VITE_ASSET__DRLggTQ6__"